import { render } from "./AreaAcademicaDetalles.vue?vue&type=template&id=4003fbf7&scoped=true"
import script from "./AreaAcademicaDetalles.vue?vue&type=script&lang=js"
export * from "./AreaAcademicaDetalles.vue?vue&type=script&lang=js"

import "./AreaAcademicaDetalles.vue?vue&type=style&index=0&id=4003fbf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4003fbf7"]])

export default __exports__